import React from "react";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Concierge } from "@/components/Concierge";

export function PublicLayout({ children, transparentNav = false }) {
  return (
    <div className="min-h-screen flex flex-col bg-paper">
      <Nav transparent={transparentNav} />
      <main className={`flex-1 ${transparentNav ? "" : "pt-16"}`}>{children}</main>
      <Footer />
      <Concierge />
    </div>
  );
}

export function Section({ children, className = "" }) {
  return <section className={`mx-auto max-w-7xl px-5 sm:px-8 ${className}`}>{children}</section>;
}

export function Eyebrow({ children }) {
  return <div className="eyebrow text-heraldic mb-4">{children}</div>;
}
